module.exports = __webpack_public_path__ + "img/logo9.6ff3070a.png";